import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { compose } from 'redux';
import { createStructuredSelector } from 'reselect';
import styled from 'styled-components';
import { Button } from '../../../../components/Buttons';
import { Calendar, IsClosed, IsOpen, View } from '../../../../components/Icon';
import { Loader } from '../../../../components/Loader';
import { VehicleHeader } from '../../../Vehicles/components/VehicleHeader';
import { performAction } from '../../actions';
import { PerformActionButton } from '../PerformActionButton';
import { BaseCellComp } from '../BaseCellComp';
import { CellButton, CellButtons } from '../CellButton';
import { HBox, VBox } from '../../../../components/Box';
import { Row, Cell } from '../../../../components/List';
import { selectAllOptions, selectVehicle } from '../../../Vehicles/selectors';
import { setVehicleProperty } from '../../../Vehicles/actions';
import { ButtonBar } from '../../../../components/ButtonBar';
import _ from 'lodash';
import DatePicker from 'react-datepicker';
import dayjs from 'dayjs';
import customParseFormat from 'dayjs/plugin/customParseFormat';

import { VehiclePropertyLoadable } from '../../../Vehicles/components/VehiclePropertyLoadable';
import { WithVehicle } from '../../../Vehicles/components/WithVehicle';

import { Cell as ActionCell } from '../Cell';
import { CompanyLabelById } from '../../../Companies/components/CompanyLabelById';
import cn from 'classnames';
import ModalComponent from '../../../../containers/App/Components/Modal/Modal';
import ButtonComponent from '../../../../containers/App/Components/Button/Button';
import styles from './HOOI.module.css';
import s from './HOOI_check_in.module.css';
import { WithUser } from '../../../Users/components/WithUser';
import { WithWorkflow } from '../../../Workflows/components/WithWorkflow';
import { selectMe, selectWork } from '../../../Api/selectors';
import { REQUEST_VEHICLE_PROPERTY_UPDATE } from '../../../Vehicles/constants';
import { VehicleLocationCard } from '../../../Vehicles/components/VehicleLocationCard';
import { VehicleHooiInstallationPhotoCard } from '../../../Vehicles/components/CardHooiInstallationPhotos';
import { VehicleProductTasksSection } from '../../../Vehicles/components/VehicleProductTasksSection';
import { CompanyLabel } from '../../../Companies/components/CompanyLabel';

dayjs.extend(customParseFormat);

const Container = styled.div`
  .modal-inner {
  }

  .pane {
    padding: 12px 0;
    border-bottom: 1px solid #eee;
    width: 100%;
    margin-bottom: 12px;
    border-bottom: none;

    .title {
      text-transform: uppercase;
    }
    h1 {
      font-size: 18px;
    }
  }

  .manco-list > div {
    margin: 12px 0;
  }

  .cell-value {
    text-align: right;
  }
`;

const RequireMark = styled.span`
  margin-left: 4 px;
  font-size: 24px;
  color: red;
`;

const Address = styled.div`
  border: 2px solid var(--color-new-secondary);
  border-radius: 6px;
  padding: 12px;
  width: 100%;
  margin: 6px 0;
  font-size: 12px;

  .button {
    margin: 0 -12px;
  }
  .name {
    font-size: 12px;
  }
  .address {
    margin-top: 12px;
  }
`;

const STATE = {
  approve: false,
  options: false,
  manco: false,
  hooi_instalation: false,
  regplate_code: '',
};

/* eslint-disable react/prefer-stateless-function */
class HOOI_check_inComp extends BaseCellComp {
  constructor(props) {
    super(props, { ...STATE });
  }

  componentDidMount() {
    const comments = this.vehicle?.properties
      ?.filter(p => p?.propertyName?.name?.startsWith('hooi_instalation_comment_'))
      ?.reduce(
        (acc, prop) => ({
          ...acc,
          [prop?.propertyName?.name]: prop?.propertyValue?.value,
        }),
        {},
      );
    this.setState({ ...comments });
  }

  get hooiInstallationPhotos() {
    return this.vehicle.documents?.filter(d => d?.type?.startsWith('photo_hooi_hooi_instalation'))?.length || 0;
  }

  reset() {
    this.setState({ ...STATE });
  }

  confirm() {
    //apprive BVI ...
    this.props.confirm(this.vehicle.id, this.state.regplate_code);
  }

  propertyValue(name) {
    return this.vehicle[name];
  }

  get vehicle() {
    return this.props.vehicle || this.props.cell.vehicle;
  }

  renderPane(name, title, content) {
    return (
      <>
        <div className="d-flex w-100">
          <div className={cn(styles.accordionHeader)} onClick={this.setStateFn({ [name]: !this.state[name] })}>
            {title}
            {name === 'Hooi_installation' && !this.hooiInstallationPhotos && <RequireMark>*</RequireMark>}
            {/* {name === 'Inslag' && !this.state.confirmLocation && <RequireMark>*</RequireMark>} */}
          </div>
          <div
            className={cn(styles.accordionIcon, { [styles.openAccordionIcon]: this.state[name] })}
            onClick={this.setStateFn({ [name]: !this.state[name] })}
          >
            {this.state[name] ? <IsClosed /> : <IsOpen />}{' '}
          </div>
        </div>
        {this.state[name] ? content : null}
      </>
    );
  }

  renderAddress = () => {
    let company = this.props.vehicle?.locationCompany;
    let address = this.props.vehicle?.locationAddress;

 

    return (
      <Address key={address?.id}>
        {company && (
          <span className="name" style={{ textTransform: 'uppercase', fontWeight: 600 }}>
            <CompanyLabel company={company} />
          </span>
        )}
        <HBox vCenter left>
         
      
        </HBox>

        <VBox left>
          <div>{address?.addressLine1}</div>
     
          {/* <div>{translateCountry(address?.country?.name, this.locale)}</div> */}
        </VBox>
      </Address>
    );
  };

  datePicker(type, disabled) {
    let format = this.vehicle[type]?.charAt?.(2) == '-' ? 'DD-MM-YYYY HH:mm' : undefined;

    let selected = this.vehicle[type] && this.vehicle[type] !== 'null' && dayjs(this.vehicle[type], format);

    return (
      <div className={cn('d-flex align-items-baseline', s.containerDatePicker)}>
        <DatePicker
          disabled={disabled}
          className={s.datePicker}
          showTimeInput
          dateFormat="dd-MM-yyyy HH:mm"
          timeFormat="HH:mm"
          selected={selected && selected != 'Invalid Date' && selected.toDate()}
          onChange={date => {
            let d = dayjs(date).format('DD-MM-YYYY HH:mm');
            this.props.setProperty(type, d);
            this.props.setProperty('HOOI_inslag_done_user_id', this.props.me?.id);
          }}
        />
        {this.props.workDate ? <Loader small /> : <Calendar className={s.iconCalendar} />}
      </div>
    );
  }

  renderApprove() {
    if (!this.state.approve) return null;

    return (
      <ModalComponent
        onClose={this.reset.bind(this)}
        title={
          <>
            {this.props.fullFetch ? (
              <>
                <Loader small />
                &nbsp;
              </>
            ) : null}
            {this.props.action.label}
          </>
        }
      >
        <WithVehicle loader vehicle_id={this.vehicle.id}>
          <div className="mb-2">
            <VehicleHeader vehicle={this.vehicle} hooikammer />
          </div>
          {this.renderAddress()}
          <Container>{this.renderModalBody()}</Container>
        </WithVehicle>
      </ModalComponent>
    );
  }

  renderModalBody() {
    return (
      <>
        <VBox key="body">
          {this.renderPane(
            'Voertuiggegevens',
            this.lbl('interior.inspection.vehicledata'),
            <VBox className="manco-list" key="manco">
              <Row>
                <Cell>{this.lbl(`vehicle.property.creditor_company`)}</Cell>
                <Cell className={'cell-value'}>
                  <CompanyLabelById company_id={this.vehicle.creditor_company} />
                </Cell>
              </Row>
           
              <Row>
                <Cell>{this.lbl(`vehicle.property.workflow `)}</Cell>

                <Cell className={'cell-value'}>
                  <WithWorkflow workflow_id={this.vehicle.workflow_id} label></WithWorkflow>
                </Cell>
              </Row>
            </VBox>,
          )}
          {/* {this.renderPhotoSection()} */}
          {this.renderPane(
            'Inslag',
            this.lbl('interior.inspection.inslag'),
            <VBox className="manco-list" key="manco">
              <Row>
                <Cell>Ingeslagen door: </Cell>
                <Cell style={{ textAlign: 'start' }}>
                  <WithUser label user_id={this.vehicle?.HOOI_inslag_done_user_id}></WithUser>
                </Cell>
              </Row>
              <Row>
                <Cell>Inslagdatum:</Cell>
                <Cell className={'cell-value'}>
                  {this.datePicker('HOOI_inslag_done_date', this.vehicle?.HOOI_inslag_done_user_id)}
                </Cell>
              </Row>
              <VehicleLocationCard vehicle={this.vehicle} />
              <HBox left>
                <ButtonComponent
                  style={'ButtonSoftEdit'}
                  onClick={() => {
                    this.setState({ confirmLocation: true });
                    this.props.setProperty('HOOI_inslag_done_user_id', this.props.me?.id);
                  }}
                >
                  Locatie bevestigen
                </ButtonComponent>
                {/* {!this.state.confirmLocation && <RequireMark>*</RequireMark>} */}
              </HBox>
            </VBox>,
          )}

          {this.renderPane(
            'Hooi_installation',
            this.lbl('vehicle.details.hooi_installation'),
            <VBox className="manco-list" key="manco">
              <VehicleHooiInstallationPhotoCard vehicle={this.props.vehicle} />
              <div>
                {this.lbl('vehicle.property.num_keys')}
                <HBox left>
                  <VehiclePropertyLoadable name="num_keys">
                    <ButtonBar>
                      {_.times(6, num => {
                        return (
                          <Button
                            key={num}
                            small
                            disabled={this.props.work}
                            primary={num == this.propertyValue('num_keys')}
                            onClick={() => {
                              this.props.setProperty('num_keys', num);
                            }}
                          >
                            {num}
                          </Button>
                        );
                      })}
                    </ButtonBar>

                    <ButtonBar></ButtonBar>
                  </VehiclePropertyLoadable>
                </HBox>
              </div>
            </VBox>,
          )}

          {this.renderPane(
            'Taken',
            this.lbl('vehicle.details.tasks'),
            <VBox className="manco-list" key="manco">
              <VehicleProductTasksSection vehicleId={this.vehicle?.id} />
            </VBox>,
          )}
        </VBox>

        <div className="d-flex gap-2 mt-3">
        <PerformActionButton
  className={styles.confirmButton}
  action={this.props.action}
  target={this.vehicle}
  onChange={() => {
    this.props.setProperty('HOOI_NEW_TASK_check_in_done', '1');
    this.reset();
  }}
/>
          <ButtonComponent style={'ButtonSoftDelete'} onClick={this.reset.bind(this)}>
            {this.lbl('cancel')}
          </ButtonComponent>
        </div>
      </>
    );
  }

  render() {
    const vehicle = this.vehicle;

    if (!vehicle || !this.props.allOptions) return <Loader small />;

    if (this.props.vehicleDetails)
      return (
        <Container>
          <HBox right>
            {this.props.cell.busy ? (
              <Loader small />
            ) : (
              <>
                <Button
                  style={'ButtonSoftEditFullWidth'}
                  primary={vehicle.HOOI_NEW_TASK_check_in_done == '1'}
                  onClick={this.setStateFn({
                    approve: !this.state.approve,
                  })}
                >
                  <b> {this.lbl('vehicle.property.binnenmelden')}</b>
                </Button>
              </>
            )}
          </HBox>
          {this.renderApprove()}
        </Container>
      );

    return (
      <ActionCell className={styles.cell}>
        <Container>
          <VehicleHeader vehicle={vehicle} hooikammer />

          <CellButtons>
            {this.props.cell.busy ? (
              <Loader small />
            ) : (
              <div className={styles.cellButtonContainer}>
                <CellButton
                  onClick={this.setStateFn({ approve: !this.state.approve, regplate_code: vehicle.regplate_code || '' })}
                >
                  <View />
                </CellButton>
              </div>
            )}
          </CellButtons>
          {this.renderApprove()}
        </Container>
      </ActionCell>
    );
  }

  onCommentChange = e => {
    const { name, value } = e.target;
    this.setState({ [name]: value });
  };
}

HOOI_check_inComp.propTypes = {
  dispatch: PropTypes.func.isRequired,
};

const mapStateToProps = (state, ownProps) =>
  createStructuredSelector({
    me: selectMe(),
    allOptions: selectAllOptions(),
    vehicle: selectVehicle(ownProps.cell.vehicle.id),
    workDate: selectWork(REQUEST_VEHICLE_PROPERTY_UPDATE + '-' + 'HOOI_inslag_done_date'),
  });

function mapDispatchToProps(dispatch, ownProps) {
  return {
    dispatch,
    confirm(vehicle_id, regplate_code) {
      dispatch(performAction(ownProps.action.id, vehicle_id, { regplate_code })).then(() => {
        dispatch(setVehicleProperty(vehicle_id, 'HOOI_NEW_TASK_check_in_done', '1'));
      });
    },

    setProperty(name, value) {
      dispatch(setVehicleProperty(ownProps.cell.vehicle.id, name, value));
    },
  };
}

const withConnect = connect(mapStateToProps, mapDispatchToProps);

export const HOOI_check_in = compose(withConnect, withRouter)(HOOI_check_inComp);
